const CONSTANTS = {
  FULLDATE: "FULLDATE",
};

const URL = {
  ADMIN_BASE_URL : `/${process.env.REACT_APP_LANGUAGE}/webmaster`
  
}

const dateTimeFormat = (dateTime, format) => {
  switch (format) {
    case "FULLDATE":
      return `${dateTime.substring(0, 10)} ${dateTime.substring(11, 19)}`;
  }
};

const urlCheck = (url) => {
  let regex = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  return regex.test(url)
}

const urlList = {
  POPUP:"/webmaster/main/popup"
}

const fileDownLoad = (fileId, fileName) => {
  const url = `${process.env.REACT_APP_API_URL}/api/file/download?fileId=${fileId}`;
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

const updateTitle = (title,enCheck) => {
  const htmlTitle = document.querySelector("title");
  htmlTitle.innerHTML = `${enCheck?'KDB Infra':'산은인프라자산운용'} ${title?` ${title}`: ''}`

};

export { CONSTANTS, URL, dateTimeFormat, urlCheck, urlList, fileDownLoad, updateTitle };

